'use client'
import { type ReactNode } from 'react'
import { useHydrateAtoms } from 'jotai/utils'
import type { PriceCalculatorPageStory } from '@/services/storyblok/storyblok'
import {
  priceCalculatorDeductibleInfoAtom,
  priceCalculatorInsuranceAmountInfoAtom,
  priceCalculatorNonTierCoverageInfoAtom,
  priceCalculatorPromoteInboundSalesAtom,
  purchaseSummaryAtom,
  tiersSectionAtom,
} from '../PurchaseForm/priceCalculatorAtoms'

type Props = {
  story: PriceCalculatorPageStory
  children: ReactNode
}

export function PriceCalculatorStoryProvider({ story, children }: Props) {
  useHydrateAtoms([
    [priceCalculatorPromoteInboundSalesAtom, story.content.promoteInboundSales ?? false],
    [priceCalculatorDeductibleInfoAtom, story.content.deductibleInfo ?? null],
    [priceCalculatorInsuranceAmountInfoAtom, story.content.insuranceAmountInfo ?? null],
    [priceCalculatorNonTierCoverageInfoAtom, story.content.nonTierCoverageInfo ?? null],
    [tiersSectionAtom, story.content.tiersSection ?? []],
    [purchaseSummaryAtom, story.content.purchaseSummaryContent ?? null],
  ])
  return children
}
